export const cardMigrationExternal = {
    targetClientId: 'C02345N6',
};
